import { Navigate, RouteObject } from "react-router";
import OrdersRoute from "@/routes/processes/[processId]/rlt/orders/orders-route";
import { OrderRoute } from "@/routes/processes/[processId]/rlt/orders/[orderId]/order-route";
import { OrderDataRoute } from "@/routes/processes/[processId]/rlt/orders/[orderId]/data/order-data-route";
import { OrderTreatmentRoute } from "@/routes/processes/[processId]/rlt/orders/[orderId]/treatment/order-treatment-route";
import { AddressesAndContactsRoute } from "@/routes/processes/[processId]/rlt/orders/[orderId]/addresses-and-contacts/addresses-and-contacts-route";
import { OrderFilesRoute } from "@/routes/processes/[processId]/rlt/orders/[orderId]/files/order-files-route";

export const rltOrdersRoutes: RouteObject[] = [
  {
    index: true,
    element: <OrdersRoute />,
  },
  {
    path: ":orderId",
    element: <OrderRoute />,
    children: [
      {
        index: true,
        element: <Navigate to="data" replace />,
      },
      {
        path: "data",
        element: <OrderDataRoute />,
      },
      {
        path: "treatment",
        element: <OrderTreatmentRoute />,
      },
      {
        path: "addresses-and-contacts",
        element: <AddressesAndContactsRoute />,
      },
      {
        path: "files",
        element: <OrderFilesRoute />,
      },
    ],
  },
];
